import { useSearchSelector } from "./search-redux-context"
import useSearchContext, { SearchContextValue } from "./use-search-context"

export function useHits<Hit = any>(searchMethods?: SearchContextValue): Hit[] {
  const { selectHits } = useSearchContext(searchMethods)
  return useSearchSelector(selectHits)
}

type UseSearchStatusReturn = { wasSearched: boolean; loading: boolean }
export function useSearchStatus(): UseSearchStatusReturn {
  const { selectStatus } = useSearchContext()
  return useSearchSelector(selectStatus)
}

export function useRegisteredFilterIds(): string[] {
  const { filters } = useSearchContext()
  return useSearchSelector(filters.selectIds)
}

export function useRegisteredFacetIds(): string[] {
  const { facets } = useSearchContext()
  return useSearchSelector(facets.selectIds)
}
